import { Button } from "antd";
import React from "react";
import "./SecondaryButton.scss";

const SecondaryButton = ({ label, icon, htmlType, loading, style, color, className, onClick, size }) => {
  return (
    <Button
      type="secondary"
      className={`btn-secondary ${color} ${className} ${size}`}
      htmlType={htmlType}
      loading={loading}
      style={style}
      onClick={onClick}>
      {label}
      {icon}
    </Button>
  );
};

export default SecondaryButton;
